/* eslint-disable react/jsx-key */
import { useEffect, useState } from 'react';
import Footer from '@/components/Layout/Footer/Footer';
import Header, { HeaderType } from '@/components/Layout/Header/Header';
import BackdropLoader from '@/components/Elements/Loader/BackdropLoader';
import { ContentLayout } from '@/components/Layout';
import i18next from 'i18next';
import { Form, InputField } from '@/components/Form';
import { Button } from '@/components/Elements';

import nextArrow from '@/assets/arrowNext.png';
import { z } from 'zod';

type FormValues = {
  title: string;
  content: string;
};
const schema = z.object({
  title: z.string().min(1, 'Required.'),
});

type FormData = z.infer<typeof schema>;

export const PropertyForSaleStepOne = () => {
  const [loading] = useState(false);

  return (
    <>
      <ContentLayout title={i18next.t('Property for Sale')}>
        <BackdropLoader open={loading} />

        <div className="property-sale-first-step">
          <div className="container">
            <div className="white-box text-center">
              <h3 className="f-36 semi-bold">Enter a short title to describe your listing</h3>
              <p className="f-18 pb-5">Make your title informative and attractive.</p>
              <Form<FormValues>
                onSubmit={async (values) => {
                  alert(JSON.stringify(values, null, 2));
                }}
                id="my-form"
              >
                {({ register, formState }) => (
                  <>
                    <InputField
                      label={i18next.t('Title')}
                      error={formState.errors['title']}
                      registration={register('title')}
                    />

                    <div className="d-flex justify-content-center mt-4">
                      <Button type="submit">
                        Let's Go <i className="fa-solid fa-arrow-right text-white"></i>
                      </Button>
                    </div>
                  </>
                )}
              </Form>
            </div>
          </div>
        </div>

        <Footer />
      </ContentLayout>
    </>
  );
};
